import { render, staticRenderFns } from "./ReminderBlock.vue?vue&type=template&id=2f2575b1&"
import script from "./ReminderBlock.vue?vue&type=script&lang=js&"
export * from "./ReminderBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReminderBlock.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReminderBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports